<!-- Este codigo fue generado por Github Copilot Chat -->
<div class="toggle-container">
  <span class="toggle-label">{{ label }}</span>
  <button
    class="toggle-button"
    [class.active]="isActive"
    (click)="onToggle()"
    [attr.aria-pressed]="isActive"
    [attr.aria-label]="label || 'Toggle button'"
    type="button"
  >
    <div class="toggle-thumb"></div>
  </button>
</div>
<!-- Este codigo fue generado por Github Copilot Chat -->
